import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FirmaDto } from '@app/dto/firma.dto';
import { FirmenstandortDto } from '@app/dto/firmenstandort.dto';
import { FirmenIndexResponseDto } from '@app/dto/firmen.index.response.dto';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { NewFirmenHauptstandortDto } from '@app/dto/newFirmenhauptstandort.dto';
import { FirmaHistoryDto } from '@app/dto/firma.history.dto';

@Injectable({
  providedIn: 'root'
})
export class FirmenService {
  private _baseUrl = `${environment.apiHost}/${environment.apiBaseUrl}`;

  public constructor(
    private readonly http: HttpClient,
  ) { }

  public getFirmen(search: string, searchFields: string, searchMode: string, queryType: string,
    orderby: string, top: number, skip: number, count: boolean, filter: string): Observable<FirmenIndexResponseDto> {
    return this.http.get<FirmenIndexResponseDto>(`${this._baseUrl}/firmen`, {
      params: {
        search, searchFields, searchMode, queryType, orderby, top, skip, count, filter
      }
    });
  }

  public getFirmaById(firmenId: number): Observable<FirmaDto> {
    return this.http.get<FirmaDto>(`${this._baseUrl}/firmen/${firmenId}`);
  }

  public getFirmenstandorteByFirmenId(firmenId: number, filter: string): Observable<FirmenstandortDto[]> {
    return this.http.get<FirmenstandortDto[]>(`${this._baseUrl}/firmen/${firmenId}/firmenstandorte`, { params: { filter } });
  }

  public patchFirma(firmenId: number, patchValue: FirmaDto): Observable<string> {
    return this.http.patch<string>(`${this._baseUrl}/firmen/${firmenId}`, patchValue);
  }

  public changeFirmenhauptstandort(firmenId: number, newFirmehauptstandort: NewFirmenHauptstandortDto): Observable<string> {
    return this.http.post<string>(`${this._baseUrl}/firmen/${firmenId}/HauptstandortAendern`, newFirmehauptstandort);
  }

  public getFirmaHistory(firmaId: number, firmenstandortId: number, take: number, skip: number): Observable<FirmaHistoryDto> {
    return this.http.get<FirmaHistoryDto>(`${this._baseUrl}/firmen/${firmaId}/historie`, { params: { firmenstandortId, take, skip } });
  }
}